// removed by extract-text-webpack-plugin
module.exports = {"base":"Checkbox_base--3Qq_N","isDisabled":"Checkbox_isDisabled--3YYGS","hasCaption":"Checkbox_hasCaption--31NUy","base__big":"Checkbox_base__big--W6c6w","baseBig":"Checkbox_base__big--W6c6w","input":"Checkbox_input--19VhU","check":"Checkbox_check--2ihol","isChecked":"Checkbox_isChecked--3zsZ_","caption":"Checkbox_caption--2tBBP"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Checkbox/Checkbox.css
// module id = 1747
// module chunks = 16